import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import OptService from '../core/_requests'
import {toast} from 'react-toastify'
import {useLocation, Route, Routes} from 'react-router-dom'
import {AcceptTermUPicLayout} from './AcceptTermLayout'
import {Policy, PolicySource} from '../core/_const'
import {ActiveSuccess} from './ActiveSuccess'
import {Button} from '../../../../_gori/partials/widgets'

const ActivateBaeGuardInsuranceComponent = () => {
  const intl = useIntl()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const token = params.get('token')
  const [isSuccess, setIsSuccess] = useState(false)
  const [isDisable, setIsDisable] = useState(false)

  const handleAccept = async () => {
    try {
      const payload = {
        token,
        policies: {
          [Policy.U_PIC]: true,
        },
        source: PolicySource.SHIPBAE,
      }
      setIsDisable(true)
      const response = await OptService.acknowledgmentToken(payload)
      if (response.status) {
        setIsSuccess(true)
        setIsDisable(false)
      }
    } catch (error: any) {
      setIsSuccess(false)
      setIsDisable(false)
      toast.error(
        error?.response?.data?.error?.message ??
          intl.formatMessage({id: 'UPDATE_TERM_AND_POLICY_FALSE'})
      )
    }
  }

  return (
    <>
      <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
        <div className='container d-flex justify-content-center mt-100px'>
          {isSuccess ? (
            <div className='w-lg-800px h-lg-350px bg-body rounded shadow-sm p-10 p-lg-10 mx-auto align-items-center'>
              <div className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'>
                <ActiveSuccess />
              </div>
            </div>
          ) : (
            <div className='w-lg-800px h-lg-300px bg-body rounded shadow-sm mx-auto mt-10'>
              <div className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'>
                <div className='card-header align-items-center text-center p-8'>
                  <div className='fw-bolder fs-2'>
                    {intl.formatMessage({id: 'ACTIVATE_BAE_GUARD_INSURANCE'})}
                  </div>
                </div>
                <div className={'card-body fw-bold fw-bolder p-10'}>
                  <div
                    className='fs-5'
                    dangerouslySetInnerHTML={{
                      __html: intl.formatMessage({id: 'TO_START_USE_BAE_GUARD'}),
                    }}
                  />
                  <div className='fs-5 mt-3'>
                    {intl.formatMessage({id: 'SIMPLE_CLICK_LINK_ACTIVATE_COVERAGE'})}
                  </div>
                </div>
                <div className={'card-footer text-center'}>
                  <Button
                    loadingText={intl.formatMessage({id: 'ACTIVATE_BAE_GUARD_COVERAGE'})}
                    className='btn btn-advanced-primary mt-8 fw-bolder fs-7 text-decoration-none text-center'
                    event={() => handleAccept()}
                    disabled={isDisable}
                  >
                    {intl.formatMessage({id: 'ACTIVATE_BAE_GUARD_COVERAGE'})}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </CSSTransition>
    </>
  )
}

const ActivateBaeGuardInsurance = () => {
  return (
    <Routes>
      <Route element={<AcceptTermUPicLayout />}>
        <Route index element={<ActivateBaeGuardInsuranceComponent />} />
      </Route>
    </Routes>
  )
}

export {ActivateBaeGuardInsurance}
